<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  /* // Import Font Awesome Icons Set */
  /* $fa-font-path: "~font-awesome/fonts/"; */
  @import "~font-awesome/css/font-awesome.min.css";
  /* // Import Simple Line Icons Set */
  /* $simple-line-font-path: "~simple-line-icons/fonts/"; */
  @import "~simple-line-icons/css/simple-line-icons.css";
</style>
<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/App.vue?0f5262b4